export const mockBeats = [
  {
    id: 'beat-10-toes',
    title: '10 Toes',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 120,
    key: 'C# Major',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/ljs8y60w21arl6v98b0sm/10-Toes.wav?rlkey=bxk8n29j2fd1a9pf0r3k9dc4d&st=m2c6pb0q&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1U_W9Bul8V3Qb6gdD1yQz7v9n38ILZCS1/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/7ed1306783f8f2f651100033eccf0d40.png'
  },
  {
    id: 'beat-one-more-lie',
    title: 'One More Lie',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 80,
    key: 'A Minor',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/rfr0ogquf2tbg79o9h3wx/One-More-Lie.wav?rlkey=v079rqu1wovtlby1ftg59gdu6&st=9i3959re&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/19vVGxCxngM-IgtmrZIVuiwgDSlCJl-I0/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/a379e6eab10f4e931034b2f0d978bd95.png'
  },
  {
    id: 'beat-telefono-trap',
    title: 'Telefono (Trap Version)',
    price: 300,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 90,
    key: 'B Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/oty8t8bwk56dfbfzkscxf/Telefono-Trap-Version.wav?rlkey=k5r6nahb1chsvtowk1jh9d1ss&st=jrrekcyz&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1726xU8Wzw2uXIEBbMp0HWjIF21oEG6Sw/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/d2db7dfdd00c9d890bf3d3be4a86dcb9.png'
  },
  {
    id: 'beat-kingdom-of-drums',
    title: 'Kingdom of Drums',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 120,
    key: 'C# Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/9kirdtqf63wmz12onqp16/Kingdom-of-Drums.wav?rlkey=s9eb1q7lyzwbnyx9kjj3nwnct&st=tl6gzqq6&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1hULYMl2aUUXZyrUWGvxwTMmPF-yydanX/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/56f5fa51d419820c49b442a7d804ade2.png'
  },
  {
    id: 'beat-cuando-llame',
    title: 'Cuando Llame',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 84,
    key: 'F Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/e2i7qcij7j9snx77lu57m/Cuando-Llame.wav?rlkey=7w8d1eijxp0lz3xqb49uy4dxn&st=81gduony&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1NBPFAmUFoXg007siERA6sC2YXV2mc9IX/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/f96bc2c8ce03516cc96e243e830f6a95.png'
  },
  {
    id: 'beat-bien-loco-trap',
    title: 'Bien Loco (Trap Version)',
    price: 250,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 85,
    key: 'G Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/x6po9pblwjq4a40njlseo/Bien-Loco-Trap-Version.wav?rlkey=5igcue0z09zpzch2riadkbz0o&st=3qyfsuwc&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1480g_-7lOxBi8x9exriSLbqDprXmwSs-/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/b58623bb252d578ff958135df287b50e.png'
  },
  {
    id: 'beat-solo-recuerdos',
    title: 'Solo Recuerdos',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 90,
    key: 'F# Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/32y8r6oj39jqmsp0ib9fx/Solo-Recuerdos.wav?rlkey=z2zp2j43c50sw3valbuyqdo6x&st=891f8ba7&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1rZos89dAtr9NXLrptCCjLBWDDAr1ZkPm/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/750f0c02f5a271eb1f1b522a27b65040.png'
  },
  {
    id: 'beat-that-life',
    title: 'That Life',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 94,
    key: 'G# Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/pmrbj4as381t98o1urow5/That-Life.wav?rlkey=rkk1gom5dmsdksucdhv30xnkc&st=gpsq2zfo&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Fx2vmhzpNgCuSAkF82ubZpo0on6uZy6X/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/e2b5cdd281274bdc6f3a5bf3ba48bb17.png'
  },
  {
    id: 'beat-2-face',
    title: '2 Face',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 95,
    key: 'G# Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/r7wpzs61zuq10ln9gi6lm/2-Face.wav?rlkey=mwzslzi2i45gd2iesy5w0o8if&st=s6wnw0la&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1nUchbx7k1a5Yc364HQoe8PdtijnJIh1P/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/ddad1df360221394064badb3056caaf3.png'
  },
  {
    id: 'beat-soft-intentions',
    title: 'Soft Intentions',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 90,
    key: 'C Minor',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/5sbdbm0cyxauvoq3y8ajm/Soft-Intentions.wav?rlkey=olitoktkfypk1phwvkav2iajy&st=8q72008s&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1fW1OCK9edn6m40TRm_ZvB0x097iBADF_/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/7aecc19b4b854b3365dd6677781f863f.png'
  },
  {
    id: 'beat-sin-decirte-nada',
    title: 'Sin Decirte Nada',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 94,
    key: 'A Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/ppakcco0ovs72jf7hv1n7/Sin-Decirte-Nada.wav?rlkey=dh15s1vpj0g29x7b5zbguyo5s&st=1k2y3kx1&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1xJ0s0pMD5wnd47M01yQva6Zq5bTfyP7g/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/7c9168553de32a86e0ef9bc192c1d41e.png'
  },
  {
    id: 'beat-lagrimas-en-club',
    title: 'Lágrimas en Club',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 92,
    key: 'C# Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/b2k4n9j33w63cgl50bl4d/L-grimas-en-Club.wav?rlkey=ieyuk77ogrqi4hlmv2v9hqsum&st=34cffrhn&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Irq0xJyLDgyLMyrDw2gtM9obV88GRewK/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/b2bfb8bda53adf87445407d2cb1ccb7a.png'
  },
  {
    id: 'beat-gucci',
    title: 'Gucci',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 146,
    key: 'F# Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/8gdhroae4mutq0oyczz5h/Gucci.wav?rlkey=zr8onlx8na6wcf674k1p5pjf1&st=64b2tcpq&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Yaz0B5nL91iPYLhqJKgAGJqbgfRkToHx/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/3108143c9b6b0992eddc5e3c29dfcfdd.png'
  },
  {
    id: 'beat-ghosted-feelings',
    title: 'Ghosted Feelings',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 87,
    key: 'G# Minor',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/g9no2fnhqbnhzytp20m4r/Ghosted-Feelings.wav?rlkey=34i6cou92kpi3ad7lzt3v405y&st=mbda7n2l&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/120h2KCvNjDKs77oUmp73Kz0UwcgNWZER/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1a4e892254832bec2d280c461ddac5ca.png'
  },
  {
    id: 'beat-pa-que-retozen',
    title: 'Pa Que Retozen (Merengue Version)',
    price: 300,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 93,
    key: 'A Minor',
    genre: ['Merengue'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/nmu4vzzy3l0gifdw67h6q/Pa-Que-Retozen.wav?rlkey=buxokyxge83f6uc5zyve3tuwc&st=qhnqq0nz&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1gQYJ-1R8DmHQaqLqgtL-iv1pZPP_4QPc/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/5898a3c2bf81dbb1bc6bc73ec0d4a215.png'
  },
  {
    id: 'beat-otra-noche',
    title: 'Otra Noche',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 115,
    key: 'A# Minor',
    genre: ['Reggaeton', 'Pop', 'EDM'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/b5suxh8nf69sv8a1r3s5g/Otra-Noche.wav?rlkey=4e8805qex4kq90oange8n5yh7&st=3bpw11qj&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1mrMxsMmmMxi8LeXIo56zqCpaAhK6MaYB/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/0a65876df433edfd7e674c0d9776945f.png'
  },
  {
    id: 'beat-private-show',
    title: 'Private Show',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 129,
    key: 'C# Minor',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/p092sniue6r9lecap6yem/Private-Show.wav?rlkey=bnvstsiolmbuxu7y1hfv6n5k2&st=4q8syboz&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1zz9lF2BiOnlf7qoWTNaZl-sfz9px1Tux/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/b2886fccc18706a6b76ce89c4e514f19.png'
  },
  {
    id: 'beat-phantom-drip',
    title: 'Phantom Drip',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 118,
    key: 'A# Minor',
    genre: ['Rap', 'Hip-Hop', 'Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/4hb29u2yfsw2ree38wkjq/Phantom-Drip.wav?rlkey=czfa3g8pnr4rrawoehr5ta9gh&st=ds4huibi&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/16bG4k49goHO3op7gmJuvV4e6Oen1yawA/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/a899722b965f055e9ec5abd11002cd6e.png'
  },
  {
    id: 'beat-unspoken-truth',
    title: 'Unspoken Truth',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 130,
    key: 'F# Major',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/re2pl6kz9pw9za8ezxien/Unspoken-Truth.wav?rlkey=8a4rc5o4sw799d1ajsjv0caru&st=wa0sdjk2&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1clIPhwYZA2YnTlTSmwnLbQibagljC6xK/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/3c1e9ac431efad668d8d1863079d2fdb.png'
  },
  {
    id: 'beat-life',
    title: 'Life',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 152,
    key: 'F# Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/huxuq8myewyg25kzm6fy7/Life.wav?rlkey=bkle2kejxj41z50c6aszpas6r&st=vmufmmai&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1g5hcmBjI6bIFvxfb45aW2QkfOM9SvA-U/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/e5cb5e70d3ab869854856e63fe0d214b.png'
  },
  {
    id: 'beat-addicted-to-you',
    title: 'Addicted to You',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 125,
    key: 'C# Major',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/mundenwm1i6hc50drrs2u/Addicted-to-You.wav?rlkey=intf6zgvkrdn2pvt8d3zt1i1f&st=rub2n8ha&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1SeR4SxKYGXYSoNpgnFAoQGGWn6MEuAV3/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/9f9618915aafad5e3d88bff202a0e318.png'
  },
  {
    id: 'beat-deactivate',
    title: 'Deactivate',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 82,
    key: 'C Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/us3a942h8oanx6nzeddn8/Deactivate.wav?rlkey=bc6nopd2sv744f06nd2w8c0wf&st=byyfgf2n&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ZExNbpSzP1ikNOiLulhIg5Wu20cLHo4r/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/e781f7d0593108941b5b3988a61c87a3.png'
  },
  {
    id: 'beat-fuiste-tu',
    title: 'Fuiste Tu',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 101,
    key: 'G# Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/skvsd1xoqhjtmq4ecebre/Fuiste-Tu.wav?rlkey=1haeiip1l83rgj79340rc2u89&st=7cb51dg4&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Kx7DQ3oW02nAMeEWouLMo9wLNieHdgxm/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/2d9a13528f69a3b23b9cc1aabb7dc037.png'
  },
  {
    id: 'beat-heat-rotation',
    title: 'Heat Rotation',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 118,
    key: 'A Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/7s7am4bddhi75xeykh2q0/Heat-Rotation.wav?rlkey=8xecpmvg3m7kxxfifgmaeh1ki&st=0br8x34k&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/12gVw2NMiSyuGxwJl_9pFWJvSKk8Sj_if/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/bc7cadfbfbb3226ef56f8deddac84ab7.png'
  },
  {
    id: 'beat-001',
    title: 'Sunset',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 117,
    key: 'E Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/m8hui70i4zwejkuxcypdl/TAG-Sunset-117BPM-EMinor.wav?rlkey=4935k1wyt61mkrvd88rbcaeeo&st=ikjt7tcw&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1G5zdSw3W2i7cqRypF4V5dqSq5fjzohgR/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/80df2e4c57f04de6cb71f85094b5d23f.png'
  },
  {
    id: 'beat-2am-energy',
    title: '2AM Energy',
    price: 175,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 142,
    key: 'F Major',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/7gvtdda9fu5hdtonkti1b/2AM-Energy.wav?rlkey=sspu4qluttfn648xh6y56sa9m&st=o2vblo1s&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1KJrm7c5VL26B9iXcqeMqfATVGKuv8c_C/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/e45899d862416997db37d88dc7f9292e.png'
  },
  {
    id: 'beat-penthouse-static',
    title: 'Penthouse Static',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 146,
    key: 'D Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/vbolhjhkasybomrxt03mj/Penthouse-Static.wav?rlkey=qtobb5i3hgvnrlgxzvegwnthk&st=mzpk5fsx&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1tiU1UCBYUyH_VqGkx6FMblBZnkNbO4nT/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/914837af9975e241837848771124f0e8.png'
  },
  {
    id: 'beat-where-do-we-stand',
    title: 'Where Do We Stand',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 154,
    key: 'A# Minor',
    genre: ['Hip-Hop', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/sf9hjsw4fjkid4dhlqndn/Where-do-we-stand.wav?rlkey=um6d7xuwgh6p6veyovbv1q4b1&st=irb0hmh0&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1mCzka6MJQLDjqK_sEQHKPzZOu7mbXtp0/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/8d4428b903e87cebd299d340f8d88c43.png'
  },
  {
    id: 'beat-sunset-palms',
    title: 'Sunset Palms',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 96,
    key: 'E Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/1y5dwp1sx5mugdrhe1yqj/Sunset-Palms.wav?rlkey=k48td14xj08hm66u1546swlta&st=hmxh2k3x&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1BKFoT66ixhEWXQ0bzjDpcABpSAz-jHVt/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/af9da7096573fc2b41cb7b662fb05928.png'
  },
  {
    id: 'beat-ignition-code',
    title: 'Ignition Code',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 84,
    key: 'C Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/5shx4t6e0xj7yo9xl7u4z/Ignition-Code.wav?rlkey=jy9kennqf0p9ojvz3ev10z7u8&st=g88xbije&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1mcf88GXr84AqGA1nVKTApzAbI67mGMP-/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/7f2d192f20557050981a90a737c668c0.png'
  },
  {
    id: 'beat-love-in-smoke',
    title: 'Love in Smoke',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 88,
    key: 'C# Minor',
    genre: [],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/w7numdk8atg8ee9a9buoz/Love-in-Smoke.wav?rlkey=03wc5kk2htsaxzr29wfo9ijjp&st=f0qc9ecc&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1j5fDb01V5GDa9Ne22zxM4dTGJlYEUrQ-/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/9981b33ddff02dc1642ebcd30c66bd0e.png'
  },
  {
    id: 'beat-siren',
    title: 'Siren',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 140,
    key: 'D# Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/fhohuk7lzcxmgchnbx308/Siren.wav?rlkey=r289ddnmwpppm90we2xcmepx3&st=ixpqd6jv&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/18O8MP3y_NqCg8xJoQ9-nJ3I3P3ihP7xt/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/2c1ddbe458e97804bce4dc00e55dee74.png'
  },
  {
    id: 'beat-corazon-nuevo',
    title: 'Corazon Nuevo',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 110,
    key: 'F Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/9jxg4lxryr5tg0nrtt009/Corazon-Nuevo.wav?rlkey=s9oeydhyzv6edkuq3j21wfygr&st=6gsfdyc6&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ZwYW5QfMyOYp7GxCYB6IEjK7tjolEJxW/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/bf90ec7e54f3a90b321cb460e65e3965.png'
  },
  {
    id: 'beat-burna-last',
    title: 'Burna Last (Latino Urbano Version)',
    price: 300,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 88,
    key: 'F Minor',
    genre: ['Pop', 'Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/xqh0wf13vcozh5lvfhwo3/Burna-Last-Last.wav?rlkey=yiv5d6zw0qigcl2roj3o0q9on&st=03q47978&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ZNW_DLaJnaJ5o1XzQpj_sI1VWD8OoylU/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/01b6e3163e19ddf75f9ddbf8cb8272d4.png'
  },
  {
    id: 'beat-go-mode',
    title: 'Go Mode',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 164,
    key: 'B Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/o4p8qo05zcl51liw61otb/Go-Mode.wav?rlkey=moonydlkhlbdtaue5od92k3ri&st=euv4twn7&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Z8DQkGWMrwQD9LCLpMmsfcZEsHGDFLTu/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/d160f8b3ac9a7276dfb14d527c3732b3.png'
  },
  {
    id: 'beat-alta-gama',
    title: 'Alta Gama',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 130,
    key: 'E Major',
    genre: ['Dembow'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/puypbh845zg26bqlukz56/Alta-Gama.wav?rlkey=pc5ylasdr5ascgc75mojsw0ib&st=3tum2kbs&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1GNaOqGxZa2X9OConDnCsN68xdv4JH0HA/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/6d66604a4d868ef62f4a273aba949fa4.png'
  },
  {
    id: 'beat-gold-feelings',
    title: 'Gold Feelings',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 130,
    key: 'C# Minor',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/ogay09zbg3bii9j02d86p/Gold-Feelings.wav?rlkey=l6bym5az8ya0xpi3k65fvjdl4&st=f8g2ir7m&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1sSZ2fNdPx3-rQL9fxOYrLumMYrHPCkah/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/ef3c73ee9fae2524f5fef7d5a84e17ed.png'
  },
  {
    id: 'beat-mami-robotica',
    title: 'Mami Robotica',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 95,
    key: 'D Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/sj4gjo5ctdlka61p0jg72/Mami-Robotica.wav?rlkey=sqzbxhot2mbrmj0u5aek9n4o3&st=h8w51rnf&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Dgmq1j6cnJJgiUHRCozqS_aoJKs5Tc2d/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/704db2952d85f4f64ee59296a8415f69.png'
  },
  {
    id: 'beat-clicks',
    title: 'Clicks',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 150,
    key: 'E Minor',
    genre: ['Hip-Hop', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/pwqp3cfsmpu4yc0vw2zh6/Clicks.wav?rlkey=wv68bxm68el5dd0itkm9lxn24&st=c1cf8v5m&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1by3X0GyQPZs18FNTU5GgbxQPAdHfktiB/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/bbbe92c08e29eb76c15909a8da162461.png'
  },
  {
    id: 'beat-pressure-wave',
    title: 'Pressure Wave',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 104,
    key: 'E Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/sj6d86vddvua4dkpp2vli/Pressure-Wave.wav?rlkey=fhfd4zghm0mdte3sw3xieie8s&st=9qwhymb9&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1swcStsrm5-Yjn_ZvD4UpMwCYIBdcmF6x/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/76815aad764c232a197daf94009805bf.png'
  },
  {
    id: 'beat-toxic-dreams',
    title: 'Toxic Dreams',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 100,
    key: 'B Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/qvjhzjjgytqqzbhy4tz66/Toxic-Dreams.wav?rlkey=jizzwzgjzucfqzjru4e067db0&st=wafcelwq&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ON81Rihhf8NMPwzCuq6cuf0aTTlhQ0-M/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/6d781b2c178700487d37932fc15927e2.png'
  },
  {
    id: 'beat-el-bloqueo',
    title: 'El Bloqueo',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 120,
    key: 'C Minor',
    genre: ['Dembow'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/l50r5kgdjo8eof6l0ewh1/El-Bloqueo.wav?rlkey=3ifwjaqaalk0909eyima3061d&st=3qwn9a4y&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1VacKsYw2MChSBD4tJaRAE67jC0UogCfK/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/5dc97d757d2f13a292833e7bfd1f86be.png'
  },
  {
    id: 'beat-the-return',
    title: 'The Return',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 121,
    key: 'Bb Major',
    genre: ['Afrobeats', 'Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/1wr8g3umla7hzosqffqcj/The-Return.wav?rlkey=8mmtd1hclfjm3lij5iwcmzmh5&st=6o1i5e8x&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1RvR6znPti8Xppp3aEU6uNUYdFk7-57LE/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/6d2c9266d1e482988b6a93aeeb43833a.png'
  },
  {
    id: 'beat-energy-surge',
    title: 'Energy Surge',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 140,
    key: 'D# Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/ymnrohlicv7s8zovlb96u/Energy-Surge.wav?rlkey=mjp03qfjxlcgsa5b3pcrxf5kv&st=biehfule&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/17fLXrFoG8xhlx6jofdVlGw3-R4ui_ZPv/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/a752001e54d963c4f965e520b35ac577.png'
  },
  {
    id: 'beat-extrana',
    title: 'Extrana',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 97,
    key: 'D Minor',
    genre: ['Reggaeton', 'Urban'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/sq5mbbd8n10q2q6n51rjr/Extrana-JMX.wav?rlkey=66ufd5x7bx5eav6oub6pkr50t&st=hf33knt8&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ZSD7puGwUJiOi4IChy9o3alOwEP_7Bjn/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/2c3703a616db2447571c36bc4282e152.png'
  },
  {
    id: 'beat-why-run',
    title: 'Why Run',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 87,
    key: 'E Minor',
    genre: ['Hip-Hop', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/t2sj7xv6wj8bx5qwxm18x/Why-Run-BPM-87-E-Minor-Tag.wav?rlkey=hz70ju4zj8k19gr3qn73mdvm8&st=z6tdaeoq&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1o49XSEGDhpyJuVnqkUtNaDE8FVkzM_fv/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/85e728cb3a97e9f010a01341e183a125.png'
  },
  {
    id: 'beat-oro-negro',
    title: 'Oro Negro',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 115,
    key: 'E Minor',
    genre: ['Dembow'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/hixjpeod902r7f2jjq8wd/Oro-Negro.wav?rlkey=66wbgyaqnn9el7f3pnvhyk0dx&st=cu1m7qoi&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1oJRn20Vsbp3bQQY52rj_EuUfVMYkcIPR/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/0ca6e6fbeed5776578f02666749fce8c.png'
  },
  {
    id: 'beat-cash-mirage',
    title: 'Cash Mirage',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 100,
    key: 'C Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/bato5xr8ntdtxyhkrjutu/Cash-Mirage.wav?rlkey=u8ggci9woamej1w7eoqfxzsgf&st=xboiv57e&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1giP1nc3pRaMD3zoOzzsSua26CLQZO0dA/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/b96691736ee2dc530e2def62ba05daaf.png'
  },
  {
    id: 'beat-infinity',
    title: 'Infinity',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 99,
    key: 'B Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/0d7audu28gl6gmxtaz3ja/Infinity-B-Minor-BPM-99.wav?rlkey=k98u3wfs8k7dsz98sc5vbgv0r&st=51ngfcmb&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ijdtRzYzoxfoK6y4V1gKeg-b8oLnvjSS/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1414979435e299d148e93815ce7fea48.png'
  },
  {
    id: 'beat-perreo-mx',
    title: 'Perreo MX',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 91,
    key: 'C Major',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/4qblaq8z6xb1zts8mtlls/Perreo-M-91-BPM.wav?rlkey=svkeq5t9nkx0sb88xuz9egbra&st=lhe017k4&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1x0RrN26tG_m0o8W-ibtSLRJYZZrzTOzg/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/3c1e1f2528e0d5f96eed9708c8394b8b.png'
  },
  {
    id: 'beat-toxic-harmony',
    title: 'Toxic Harmony',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 100,
    key: 'C Major',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/cl4e0m8koue3dtx9hf8h4/Toxic-Harmony.wav?rlkey=rg1bnztx9u5sc7zg3u86zwwdr&st=vjk94s86&dl=1',
    downloadUrl: 'https://dl.dropboxusercontent.com/scl/fi/cl4e0m8koue3dtx9hf8h4/Toxic-Harmony.wav?rlkey=rg1bnztx9u5sc7zg3u86zwwdr&st=7j22f6o3&dl=1',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/38e365d1cfea1d8aa341eb78d756d92f.png'
  },
  {
    id: 'beat-chrome-nights',
    title: 'Chrome Nights',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 103,
    key: 'B Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/eanndgbm657328q0mdv5d/Chrome-Nights.wav?rlkey=bkro0q41o368ocuq0kyaejrqy&st=9xw395dh&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1hdiEcqldMuVsnUScdefg58boEubRQZOX/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/cd169c39961b67469fbd7379e8bfd85d.png'
  },
  {
    id: 'beat-war-cry',
    title: 'War Cry',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 80,
    key: 'D# Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/cmwh3tmb9ykyrgnu70qf9/War-Cry.wav?rlkey=eqrby0wduqbyin8stmzo5t1hv&st=n18un9vn&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/11eIsv0eg6pFOrKYIOQ3xBni5_XOI8aHI/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/efce866224012b5c4246fca27ab3ec1a.png'
  },
  {
    id: 'beat-004',
    title: 'Arcangel Pa Que ( Trap Version )',
    price: 300,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 110,
    key: 'B Minor',
    genre: ['Reggaeton', 'Trap', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/vlunfr0lx3ag23k4i60ka/Arcangel-Pa-Que-Sample.wav?rlkey=fl198afwuc5847wcwp9qe0f8d&st=lw4bs8lt&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1dwgNk53jmxsgUGS7HoFhnZM2cpFA8NoW/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/a02d05937f9b872c41fb0407f2d483ca.png'
  },
  {
    id: 'beat-desert-crown',
    title: 'Desert Crown',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 120,
    key: 'E Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/kqsu30edl6uiobsncsv12/Desert-Crown.wav?rlkey=6ajntp0psfaj80h9f4w038n82&st=cghp4adg&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1wVlnKywSlni6iReGCSmqWjbD8-xVWlYZ/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1df7ba4bce33867da9053f834f811fd3.png'
  },
  {
    id: 'beat-golden-breeze',
    title: 'Golden Breeze',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 97,
    key: 'B Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/34mkadz3o6qra0bow943l/Golden-Breeze.wav?rlkey=6q893secykkedhmo3a6vgkpzp&st=ihfk0ooc&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1HJAfkgyzrXaSZmD3_FO6KkQhB76CHynL/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/c3ba2911eafe3bc7db0fa4adff49cd74.png'
  },
  {
    id: 'beat-pay-me',
    title: 'Pay Me',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 168,
    key: 'D Minor',
    genre: ['Hip-Hop', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/phskei07sfaix3b4xctjr/Pay-Me.wav?rlkey=5iag4zi7dm29xz2szvu8l8qoi&st=420czd9a&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1W_Y79b95LimBKLAJNwGLdAJhh8-dXz0f/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/d229f146db30ff9d5c51792405afb738.png'
  },
  {
    id: 'beat-drums-of-destiny',
    title: 'Drums of Destiny',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 89,
    key: 'D# Minor',
    genre: ['Afro Beats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/kq6nd34oj866p759k9lvu/Drums-of-Destiny.wav?rlkey=bonx00u3rb70tmhtng6h3i0dd&st=hwtqzp1g&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1-scoGM50oBQ8Qp2Qmzf9S0ibfuD_oxCu/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/ccfe0dcf76838ba5768e9fc5dd42bc4c.png'
  },
  {
    id: 'beat-suena-con-migo',
    title: 'Suena Con Migo',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 85,
    key: 'D Major',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/r4q6yk0ls6mojk4rxhgs4/Suena-Con-Migo.wav?rlkey=o6xtz3f84tal8crnxncc8k1gb&st=a3yepr03&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1418ylf64VlR4vrcBW9QjLXR7QPlX5DS0/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1f69c512c3646b641e6ba2292a5cc968.png'
  },
  {
    id: 'beat-rich-silence',
    title: 'Rich Silence',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 129,
    key: 'C Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/qpymz60keewzrihpha6j0/Rich-Silence.wav?rlkey=wi5t9cywx7bsb0yw9xhranw3m&st=t2hvlk4g&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/12m-_m_rzvyT2_tJpJB3m7eSnj4zIc-1h/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/2c827e5acf29efa48046989fb976fa91.png'
  },
  {
    id: 'beat-lock-in',
    title: 'Lock In',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 87,
    key: 'G Minor',
    genre: [],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/754buwilz7iup5a4mumj6/Lock-In.wav?rlkey=e79xonbheeh1drtqp4zb4g377&st=hjb1qwlv&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1Ps1-is8x8zayD0-caj834y7GN70ouUux/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/3df9f89f81593e8dfea7e51fe26b4d42.png'
  },
  {
    id: 'beat-lets-dance',
    title: 'Lets Dance',
    price: 0,
    licenseType: 'Exclusive',
    isFree: true,
    sold: false,
    bpm: 108,
    key: 'Bb Minor',
    genre: ['Hip-Hop'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/8gvkomwgsfym0prw6dxt9/Lets-Dance-BPM-108-Bb-Minor-Tag.wav?rlkey=52va6dsxsaj078s35zr79ncj9&st=00mttnhi&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1qWoKxzAS2r1mdopxOo2NpEbA7kblMCf5/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/857a0f7791e2baaa56063c8c70bec0ac.png'
  },
  {
    id: 'beat-fiesta-809',
    title: 'Fiesta 809',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 122,
    key: 'E Major',
    genre: ['Dembow', 'Merengue'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/p3ko8e9zurm3xxl976k1c/Fiesta-809.wav?rlkey=563likzy7tk8sfuzuc44jbdc9&st=7i56dcc1&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1yGbImFCAo4k06nT7We_73pUdRIqsUryS/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/64e244102d41380d8b4399022f47d59c.png'
  },
  {
    id: 'beat-velvet-nights',
    title: 'Velvet Nights',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 124,
    key: 'B Minor',
    genre: ['R&B'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/d51ekbqpyuizxu6djqd02/Velvet-Nights.wav?rlkey=zektjiukfirpzofdmdk5j25ex&st=1inl01f1&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1y_EAddnxRaes2YlRfBCI_vL1wV0ZgwIH/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/ac9c79775681bd90086264c1cd447714.png'
  },
  {
    id: 'beat-heavy-motion',
    title: 'Heavy Motion',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 164,
    key: 'B Major',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/dy94dhwy3q8g2zmweazi7/Heavy-Motion.wav?rlkey=6syup5agz4yogxkoqoc5dc6n0&st=c31gd9k6&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1rBj4phVdkqybV-yF3qDRxHM8krHRxOZM/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/6731c46d5092a9e3c916126d22300d9a.png'
  },
  {
    id: 'beat-bloodline-rhythm',
    title: 'Bloodline Rhythm',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 104,
    key: 'A Major',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/7tg6uefmxgdufm91h90b3/Bloodline-Rhythm.wav?rlkey=bzunlggy4syxsqnz9y6uq352a&st=314sa2gl&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1yijyhwH8nbpr262E_E0QE1qNOHGLaDsO/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/025f508659cd9e6c4682f667a309ab6e.png'
  },
  {
    id: 'beat-black-house',
    title: 'Black House',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 90,
    key: 'F Minor',
    genre: ['Afrobeats', 'Trap', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/48kkxd2hd8dxhks712upp/Black-House.wav?rlkey=958twbaobrfehximwvso2warn&st=3ujnha9j&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1yijyhwH8nbpr262E_E0QE1qNOHGLaDsO/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1360b603555ab225cc6305830fd12747.png'
  },
  {
    id: 'beat-martillo',
    title: 'Martillo',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 100,
    key: 'C Minor',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/38be1g90th2wc6f13r0ay/Martillo-JMX-beat.wav?rlkey=litfymbvsj61fogc7qyjpnyl9&st=5py2365h&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1mtg5w7NMZIPzgc_VKZTo8i6cMlX9724J/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/b2f86852e61b7ae6d667667d783070f1.png'
  },
  {
    id: 'beat-zona',
    title: 'Zona Caliente',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 114,
    key: 'C Major',
    genre: ['Dembow'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/5q3i8akz7cnellfvx0wuk/Zona-Caliente.wav?rlkey=ejqbty38d5h00ubbmfgalvbwq&st=pb37fkds&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1smJXa9TmHRiHX3nlEbfkIYd-EZF-MTaZ/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/f1fb74a7c85e04b63d08c7691f1901aa.png'
  },
  {
    id: 'beat-one-momment',
    title: 'One Momment',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 136,
    key: 'D Minor',
    genre: ['Hip-Hop', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/g7ie436zt9z7sx75fthhn/One-Momment-136-BPM-D-Minor.wav?rlkey=wvjqs8waa18olakcdloyd1ckw&st=w5pfbyhq&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ZeV_rkmCR9l2Llpue7szIKUD48kkze3a/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/75e730dcf01bc5c5084a273ba0cb47f6.png'
  },
  {
    id: 'beat-ghost-signal',
    title: 'Ghost Signal',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 140,
    key: 'A Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/e062w7852y4h4wkau4qez/Ghost-Signal.wav?rlkey=mgvlicj1xdkepujhngqbncwnr&st=88nx5izb&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1zj8xnpcr_5XBt4-513akryLMpfj93HNt/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/bf32d32cc13fbaa34b9c41c77497669e.png'
  },
  {
    id: 'beat-002',
    title: 'Kuriosa',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 95,
    key: 'Ab Major',
    genre: ['Reggaeton'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/xlsnnpgw81u4bsrre2y15/Kuriosa-95-BPM.wav?rlkey=5mdmz2i1u000ecn611m56krf0&st=1ts75ki4&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1VEUMFVWn4KYU4Dx15wDbI58deqwlIv7a/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/784686c79bedc110c1bd2b5b900dca6e.png'
  },
  {
    id: 'beat-tribal-awakening',
    title: 'Tribal Awakening',
    price: 200,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 90,
    key: 'E Minor',
    genre: ['Afrobeats'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/eghh2owo81cg5c7x4htfb/Tribal-Awakening.wav?rlkey=bormqozejbrr61wxn30o9fxmo&st=cht288fi&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/13rQFX7_0jEtWuV1WxCqNUlrayDDNCFDX/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/84d3be9cd37388e356d824c166c70e31.png'
  },
  {
    id: 'beat-super-drop',
    title: 'Super Drop',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 140,
    key: 'B Minor',
    genre: ['Trap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/0gmuu2gtnk26pwk9apxps/Super-Drop.wav?rlkey=h7jp9vb2f5rbe2zxnerlulso1&st=msr3gxlj&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1RPPWoecv6jVVQlkFQCbqHFOmtPS6Bo1X/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/f7b0c82c850ac70a86f1b28efbd1f834.png'
  },
  {
    id: 'beat-005',
    title: 'Or Nah (Drill Version)',
    price: 300,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 160,
    key: 'G# Minor',
    genre: ['Drill', 'Rap'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/21p9skkrr9owrl67rkggg/Dick-or-Nah-Beat.wav?rlkey=863qgvldd1frytirmqp34gab8&st=qycity1l&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1BhWjlGqncxzBJRzSr38AqncOIB0tO0cq/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/4e082e4db85c872ce1bbf6ac4ce75624.png'
  },
  {
    id: 'beat-projectmx',
    title: 'Project MX',
    price: 150,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 114,
    key: 'C Minor',
    genre: ['House', 'EDM'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/8y0nkwwm411utsotqlcj7/Project-MX-C-Minor-BPM-114.wav?rlkey=7d7vnzgq4829mh5d7uuvh4fu4&st=zhewlbb2&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1ODm-8W08FgpghIg09b-OpkoiyL95T5y0/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/ce48003cc5458d60458f70b08ed55fdd.png'
  },
  {
    id: 'beat-that-i-love-you',
    title: 'That I Love You (Rap Sample)',
    price: 300,
    licenseType: 'Exclusive',
    isFree: false,
    sold: false,
    bpm: 91,
    key: 'D# Minor',
    genre: ['Rap', 'Hip-Hop'],
    audioUrl: 'https://dl.dropboxusercontent.com/scl/fi/hu0k10qkeuvjr8izz9lch/That-I-Love-you.wav?rlkey=jxulrf5fk8u6qtn8t2jck14zv&st=8wfjpqxm&dl=1',
    downloadUrl: 'https://drive.google.com/file/d/1NlJGu70eoICdi1lH6p_xgXYXii5b9-Cm/view?usp=drive_link',
    waveformImage: 'https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1a09e45cc99a72af8340405f8bb72f32.png'
  }
];
